module.exports = __webpack_public_path__ + "img/exam_jan_2025_0kluo37a.8286895d.jpg";